import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import Icon from '../forms/Icon';
import { generateId } from '../utility/functions';
import { SCREEN_MAX_WIDTH } from '../stateProvider/StateProvider';
import { TableContext } from './Table';

const Wrapper = styled.div`
    color: ${({ theme }) => theme.contrast};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    min-width: 12em;
    padding: 0.5em;
    border-radius: 10px;
    transition: background,  0.5s;
    position: relative;
    background: ${({ color }) => color};
    
    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        width: 100%;
    }
`;

const Animation = styled.div`
    margin: ${({ active }) => active ? '0 1rem' : '0'};
    text-align: center;
    white-space: nowrap;
    width: ${({ active }) => active ? '20px' : '100%'};
    transition: width, margin, .5s ease;
`;

const Text = styled(Animation)`
    font-weight: 600;
    font-size: 1.1em;
`
const Number = styled(Animation)`
    font-weight: 600;
    font-size: 1.5em;
`
const I = styled(Icon)`
    position: absolute;
    font-size: 1.5em;
    bottom: 0.4em;
    right: 1rem;
    opacity: ${({ active }) => active ? '1' : '0'};
    transition: opacity .3s ease;
`

const Sticker = ({ callback, ...props }) => {
    const { tableData } = useContext(TableContext);
    const [id] = useState(generateId());

    return (
        <Wrapper color={props.color} key={id}>
            <Text>{props.label}</Text>
            <Number>{callback(tableData)}</Number>
        </Wrapper>
    );
}

export default Sticker;